import {useContext, useEffect} from 'external/react'
import Catalog from 'context/catalog-context'
import {inViewer} from 'settings'


window.downloadedContentCB = undefined
window.downloadedContent = {}
window.setDownloadedContent = raw => {
  const content = raw.reduce((acc, {id, hash}) => ({...acc, [id]: hash}), {})
  window.downloadedContent = content
  if (window.downloadedContentCB) window.downloadedContentCB(content)
}

export default function useCatalog () {
  const {state, update} = useContext(Catalog.Context)
  const {subjects, grades, units, unitsCourse, unitLessons, downloadedContent} = state
  const has = (properties, test = i => i != undefined) => properties.every(name => test(state[name]))

  const isDownloaded = ({id, hash}) => {
    return inViewer && (downloadedContent[id] == hash)
  }

  useEffect(() => {
    if(window.downloadedContent)
      update({downloadedContent: {$set: window.downloadedContent}})
    window.downloadedContentCB = content => update({downloadedContent: {$set: content}})
  }, [])

  return {subjects, grades, has, units, unitsCourse, unitLessons, update, isDownloaded}
}
